/**
 * Quote Service
 * Handles all quote-related API requests
 */
import apiClient from './api';

const quoteService = {
  /**
   * Submit a new quote request
   * @param {Object} quoteData - The quote form data
   * @returns {Promise} - Promise with the API response
   */
  submitQuote(quoteData) {
    return apiClient.post('/api/quotes', quoteData);
  },

  /**
   * Get a specific quote by ID
   * @param {string|number} id - The quote ID
   * @returns {Promise} - Promise with the API response
   */
  getQuote(id) {
    return apiClient.get(`/api/quotes/${id}`);
  },

  /**
   * Get all quotes for a customer
   * @param {string|number} customerId - The customer ID
   * @returns {Promise} - Promise with the API response
   */
  getQuotes(customerId) {
    return apiClient.get('/api/quotes', { params: { customerId } });
  },

  /**
   * Update an existing quote
   * @param {string|number} id - The quote ID
   * @param {Object} quoteData - The updated quote data
   * @returns {Promise} - Promise with the API response
   */
  updateQuote(id, quoteData) {
    return apiClient.put(`/api/quotes/${id}`, quoteData);
  },

  /**
   * Delete a quote
   * @param {string|number} id - The quote ID to delete
   * @returns {Promise} - Promise with the API response
   */
  deleteQuote(id) {
    return apiClient.delete(`/api/quotes/${id}`);
  },

  /**
   * Get product information for quote form
   * @param {string} productType - The product type (e.g., 'home', 'auto')
   * @returns {Promise} - Promise with the API response
   */
  getProductInfo(productType) {
    return apiClient.get(`/api/products/${productType}`);
  }
};

export default quoteService; 